import React, { useState } from "react";

const SinkSelector = ({ canEdit, value, onChange }) => {
  const [loading, setLoading] = useState(false);

  const sinks = [
    {
      name: "Sink 1",
      image:
        "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink1.jpg",
    },
    {
      name: "Sink 2",
      image:
        "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink2.jpg",
    },
    {
      name: "Sink 3",
      image:
        "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink3.jpg",
    },
    {
      name: "Sink 4",
      image:
        "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink4.jpg",
    },
    {
      name: "Sink 5",
      image:
        "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink5.jpg",
    },
    {
      name: "Sink 6",
      image:
        "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink6.jpg",
    },
    {
      name: "Sink 7",
      image:
        "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink7.jpg",
    },
    {
      name: "Sink 8",
      image:
        "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink8.jpg",
    },
    {
      name: "Sink 9",
      image:
        "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink9.jpg",
    },
    {
      name: "Sink 10",
      image:
        "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink10.jpg",
    },
    {
      name: "Sink 11",
      image:
        "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink11.jpg",
    },
    {
      name: "Sink 12",
      image:
        "https://cdn.jsdelivr.net/gh/foreverkatie123/selection-images/kitchen-sink/sink12.jpg",
    },
  ];

  const selectedSink = sinks.find((s) => s.name === value);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        gap: "2rem",
        marginTop: "1rem",
      }}
    >
      {/* LEFT SIDE: Thumbnail Grid */}
      <div style={{ flex: "1 1 400px", minWidth: "300px" }}>
        <p style={{
            display: 'block',
            marginBottom: '0.5rem',
            fontSize: '14px',
            fontWeight: '600',
            color: '#333'
        }}>
          Kitchen Sink Options
        </p>
        <p style={{ fontSize: "0.9rem", color: "#555", marginBottom: "1rem" }}>
          Click on a sink to preview
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
            gap: "1rem",
          }}
        >
          {sinks.map((sink) => (
            <div
              key={sink.name}
              onClick={() => {
                if (canEdit) {
                  onChange(sink.name);
                  setLoading(true);
                }
              }}
              style={{
                cursor: canEdit ? "pointer" : "not-allowed",
                opacity: !canEdit ? 0.6 : 1,
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: "100px",
                  borderRadius: "8px",
                  border: value === sink.name ? "3px solid #007bff" : "2px solid #ddd",
                  boxShadow: value === sink.name ? "0 4px 12px rgba(0,123,255,0.3)" : "0 2px 4px rgba(0,0,0,0.1)",
                  transition: "all 0.2s",
                  transform: value === sink.name ? "scale(1.05)" : "scale(1)",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  src={sink.image}
                  alt={sink.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
                {value === sink.name && (
                  <div
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      backgroundColor: "#007bff",
                      color: "white",
                      borderRadius: "50%",
                      width: "24px",
                      height: "24px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "14px",
                      fontWeight: "bold",
                    }}
                  >
                    ✓
                  </div>
                )}
              </div>
              <p
                style={{
                  margin: "0.5rem 0 0 0",
                  fontSize: "0.75rem",
                  textAlign: "center",
                  color: value === sink.name ? "#007bff" : "#333",
                  fontWeight: value === sink.name ? "600" : "400",
                }}
              >
                {sink.name}
              </p>
            </div>
          ))}
        </div>

        {!canEdit && (
          <p style={{ marginTop: "1rem", fontSize: "0.85rem", color: "#dc3545", fontStyle: "italic" }}>
            Sink selection is locked. Contact administrator to make changes.
          </p>
        )}
      </div>

      {/* RIGHT SIDE: Large Preview */}
      <div
        style={{
          flex: "1 1 300px",
          minWidth: "250px",
          textAlign: "center",
          position: "relative",
        }}
      >
        {selectedSink ? (
          <>
            {loading && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 2,
                }}
              >
                <div
                  style={{
                    width: "36px",
                    height: "36px",
                    border: "4px solid #ccc",
                    borderTop: "4px solid #007bff",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                  }}
                ></div>
              </div>
            )}

            <img
              src={selectedSink.image}
              alt={selectedSink.name}
              onLoad={() => setLoading(false)}
              onError={() => setLoading(false)}
              style={{
                width: "100%",
                maxWidth: "400px",
                borderRadius: "8px",
                border: "2px solid #007bff",
                boxShadow: "0 4px 12px rgba(0,123,255,0.3)",
                opacity: loading ? 0.3 : 1,
                transition: "opacity 0.3s ease",
              }}
            />

            <div
              style={{
                marginTop: "0.75rem",
                fontWeight: "bold",
                fontSize: "1.1rem",
                color: "#007bff",
              }}
            >
              {selectedSink.name}
            </div>
          </>
        ) : (
          <div
            style={{
              color: "#777",
              fontStyle: "italic",
              marginTop: "2rem",
              padding: "3rem",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px",
              border: "1px dashed #ccc",
            }}
          >
            Select a sink to preview
          </div>
        )}
      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default SinkSelector;